import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import Layout from '../components/Layout';
import { usePolling } from '../hooks/usePolling';
import { N8N_STATUS_WEBHOOK } from '../config';

/**
 * WaitingPage – zwei Phasen:
 *
 * Phase 1: ?cid=<correlation_id>
 *   → Pollt n8n auf stripe_url
 *   → Sobald vorhanden: redirect zu Stripe Checkout
 *
 */
export default function WaitingPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const cid       = searchParams.get('cid') ?? sessionStorage.getItem('correlation_id');
  
  // cid im sessionStorage persistieren, damit er nach Stripe-Redirect noch da ist
  useEffect(() => {
    if (cid) sessionStorage.setItem('correlation_id', cid);
  }, [cid]);

  // Poll-URL für n8n
  const pollUrl = cid
    ? `${N8N_STATUS_WEBHOOK}?cid=${cid}`
    : null;

  const { data, error, timedOut } = usePolling(
    pollUrl,
    (json) => {
      return !!json.stripe_url;
    }
  );

  // Phase 1: Stripe URL erhalten → weiterleiten
  useEffect(() => {
    if (data?.processed === true) {
      navigate(`/thank-you?cid=${cid}`)
    } else if (data?.stripe_url) {
      window.location.href = data.stripe_url;
    }
  }, [data]);

  // ── UI ────────────────────────────────────────────────────────────────────

  if (!cid) {
    return (
      <Layout
        title="Error"
        description="No Session ID found. Please re-submit the form."
      />
    );
  }

  if (error) {
    return (
      <Layout
        title="Connection Error"
        description={`We could not establish a network connection to our servers: ${error}`}
      />
    );
  }

  if (timedOut) {
    return (
      <Layout
        title="Timeout Error"
        description="The connection timed out. Please try again."
      />
    );
  }

  return (
    <Layout
      title="One moment please..."
      description="Your request is being processed and payment is being prepared."
    >
      <Spinner />
    </Layout>
  );
}

function Spinner() {
  return (
    <div style={{ marginTop: '1.5rem', display: 'flex', justifyContent: 'center' }}>
      <div style={{
        width: 32,
        height: 32,
        borderRadius: '50%',
        border: '3px solid var(--color-border)',
        borderTopColor: 'var(--color-accent)',
        animation: 'spin 0.8s linear infinite',
      }} />
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
}
